import React, { useEffect, useState } from 'react';
import { CalendarPlus, ChevronDown } from 'lucide-react';
import api from '../../services/api';
import { MultiDatePicker } from './MultiDatePicker';
import { toRuns } from './GroupDatesSelector';

// HR helper inside the multi-range form: pick separate dates / repeat weekly, then add them as 1-day ranges.
export const HrSeparateDates = ({ leaveType, onAdd }) => {
  const [cfg, setCfg] = useState(null);
  const [open, setOpen] = useState(false);
  const [dates, setDates] = useState([]);
  useEffect(() => { api.get('/api/leaves/multi-date-settings').then((r) => setCfg(r.data)).catch(() => {}); }, []);
  if (!cfg?.enabled || (cfg.excluded_types || []).includes((leaveType || '').toLowerCase())) return null;
  return (
    <div className="rounded-md border border-sky-200 bg-sky-50/30" data-testid="hr-separate-dates">
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-3 py-2 text-sm text-sky-800 font-medium" data-testid="hr-separate-dates-toggle">
        <span className="flex items-center gap-1.5"><CalendarPlus className="h-4 w-4" />Pick separate dates / repeat weekly</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-2">
          <MultiDatePicker dates={dates} onChange={setDates} allowPast maxDaysAhead={cfg.max_days_ahead} max={cfg.max_dates} testPrefix="hr-md" />
          <button type="button" disabled={!dates.length} onClick={() => { onAdd(toRuns(dates)); setDates([]); setOpen(false); }}
            className="w-full py-1.5 rounded-md bg-sky-600 text-white text-sm disabled:opacity-40 hover:bg-sky-700 transition-colors" data-testid="hr-md-add-to-ranges">
            Add {dates.length || ''} day{dates.length === 1 ? '' : 's'} to the ranges list
          </button>
        </div>
      )}
    </div>
  );
};
